// All LMS event names in one place.
// Use these constants everywhere — never hardcode strings.
// TypeScript will catch typos at compile time.

export const LMS_EVENTS = {
  // ── Auth ──────────────────────────────────────────────────────────────────
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',

  // ── Navigation (auto-tracked via RouteAnalytics) ──────────────────────────
  PAGE_VIEWED: 'page_viewed',

  // ── Course Listing ────────────────────────────────────────────────────────
  COURSES_PAGE_VIEWED: 'courses_page_viewed',
  COURSE_CARD_CLICKED: 'course_card_clicked',
  COURSE_FILTER_APPLIED: 'course_filter_applied',

  // ── Course Landing ────────────────────────────────────────────────────────
  COURSE_LANDING_VIEWED: 'course_landing_viewed',
  COURSE_PLAYER_ENTERED: 'course_player_entered',

  // ── Course Player ─────────────────────────────────────────────────────────
  COURSE_PLAYER_OPENED: 'course_player_opened',
  COURSE_STEP_VIEWED: 'course_step_viewed',
  COURSE_STEP_COMPLETED: 'course_step_completed',
  COURSE_NAV_NEXT: 'course_nav_next',
  COURSE_NAV_PREV: 'course_nav_prev',
  COURSE_SIDEBAR_ITEM_CLICKED: 'course_sidebar_item_clicked',

  // ── Quiz ──────────────────────────────────────────────────────────────────
  QUIZ_STARTED: 'quiz_started',
  QUIZ_PAGE_NAVIGATED: 'quiz_page_navigated',
  QUIZ_SUBMITTED: 'quiz_submitted',
  QUIZ_REVIEW_OPENED: 'quiz_review_opened',

  // ── Feedback ──────────────────────────────────────────────────────────────
  FEEDBACK_STARTED: 'feedback_started',
  FEEDBACK_SUBMITTED: 'feedback_submitted',

  // ── Resources ─────────────────────────────────────────────────────────────
  RESOURCE_VIEWED: 'resource_viewed',
  VIDEO_PLAYED: 'video_played',
  VIDEO_PAUSED: 'video_paused',
  VIDEO_COMPLETED: 'video_completed',
  PDF_OPENED: 'pdf_opened',
  PDF_PAGE_CHANGED: 'pdf_page_changed',
  AUDIO_PLAYED: 'audio_played',
  FILE_DOWNLOADED: 'file_downloaded',

  // ── Interactive Tools ─────────────────────────────────────────────────────
  TOOL_STARTED: 'tool_started',
  TOOL_SCREEN_ADVANCED: 'tool_screen_advanced',
  TOOL_COMPLETED: 'tool_completed',

  // ── Assessment ────────────────────────────────────────────────────────────
  ASSESSMENT_QUESTION_ANSWERED: 'assessment_question_answered',

  // ── H5P Activities ────────────────────────────────────────────────────────
  H5P_ACTIVITY_VIEWED: 'h5p_activity_viewed',
  H5P_ACTIVITY_COMPLETED: 'h5p_activity_completed',

  // ── Page Activity ─────────────────────────────────────────────────────────
  PAGE_ACTIVITY_VIEWED: 'page_activity_viewed',

  // ── Focus Timer ───────────────────────────────────────────────────────────
  FOCUS_TIMER_STARTED: 'focus_timer_started',
  FOCUS_TIMER_PAUSED: 'focus_timer_paused',
  FOCUS_TIMER_COMPLETED: 'focus_timer_completed',

  // ── Media Player Tool ─────────────────────────────────────────────────────
  MEDIA_PLAYER_STARTED: 'media_player_started',
  MEDIA_PLAYER_COMPLETED: 'media_player_completed',

  // ── Auth ──────────────────────────────────────────────────────────────────
  LOGIN_FAILED: 'login_failed',

  // ── Errors ────────────────────────────────────────────────────────────────
  ERROR_BOUNDARY_TRIGGERED: 'error_boundary_triggered',
} as const;

export type LmsEventName = (typeof LMS_EVENTS)[keyof typeof LMS_EVENTS];
